<template>
    <div>
        <div>
            <logo/>
        </div>
        <div class='sidebar_nav'>
            <sidebar class="sidebar-container"/>
        </div>
        <div class="main">
            <router-view :key="key"/>
        </div>
    </div>
</template>

<script>
import Logo from "./components/logo.vue";
import Sidebar from "./components/sidebar.vue";
export default {
    components:{ Sidebar , Logo},
    computed:{
        key() {
            return this.$route.path
        },
    },
    data() {
        return {

        };
    },
    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="less">
    .sidebar_nav{
        background:#0B2154
    }
</style>
